import React, { useState } from 'react';
import { FINAL_RESULT_RULES } from '../utils/finalResultRule.js';

// The Final Result Rule info icon, shared by Add/Edit Pricing Template, the
// Pricing Template table header and the Pricing Template drawer so the wording
// stays identical in all three.
//
// Styled after the Platform Stock inconsistency tooltip on Platform Listing
// (StockInconsistencyBadge in PlatformListingTest): the same 10px grey info
// glyph and the same compact #495057 bubble with a shadow and an 8px arrow.
// The bubble is position:fixed against the icon's viewport rect, which is what
// lets it escape the th's overflow:hidden — neither the table wrapper nor the
// drawer sets a transform, so no ancestor becomes a containing block for it.
export default function FinalResultRuleTooltip() {
    const [tip, setTip] = useState(null);

    const showTip = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        // Anchored by its bottom edge so the bubble grows upward and keeps an
        // 8px gap above the icon however tall the rule list gets.
        setTip({ left: r.left + r.width / 2, bottom: window.innerHeight - r.top + 8 });
    };

    return (
        <>
            <span
                style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', marginLeft: 3, flexShrink: 0 }}
                onMouseEnter={showTip}
                onMouseLeave={() => setTip(null)}
                onClick={(e) => e.stopPropagation()}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                    <path d="M5.58122 4.11768L4.14997 4.29705L4.09872 4.53455L4.37997 4.58643C4.56372 4.63018 4.59997 4.69643 4.55997 4.87955L4.09872 7.04705C3.97747 7.60768 4.16435 7.87143 4.60372 7.87143C4.94435 7.87143 5.33997 7.71393 5.51935 7.49768L5.57434 7.23768C5.44934 7.34768 5.26684 7.39143 5.1456 7.39143C4.97372 7.39143 4.91122 7.2708 4.9556 7.0583L5.58122 4.11768Z" fill="#5E6E82" />
                    <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                </svg>
            </span>
            {tip && (
                <div
                    style={{
                        position: 'fixed',
                        left: tip.left,
                        bottom: tip.bottom,
                        transform: 'translateX(-50%)',
                        maxWidth: 220,
                        whiteSpace: 'normal',
                        background: '#495057',
                        color: '#FFFFFF',
                        borderRadius: 8,
                        padding: '10px 12px',
                        fontFamily: 'Montserrat',
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: 1.4,
                        boxShadow: '0px 4px 20px rgba(0,0,0,0.32)',
                        zIndex: 9999,
                        pointerEvents: 'none',
                    }}
                >
                    {FINAL_RESULT_RULES.map((rule, idx) => (
                        <div key={rule.value} style={idx > 0 ? { marginTop: 8 } : undefined}>
                            <strong>{rule.label}:</strong> {rule.description}
                        </div>
                    ))}
                    <div
                        style={{
                            position: 'absolute',
                            bottom: -8,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderTop: '8px solid #495057',
                        }}
                    />
                </div>
            )}
        </>
    );
}
